import Vue from 'vue'
import VueRouter from 'vue-router'
import Auth from '@/mixins/auth.js'
// import Home from '../views/Home.vue'
// import MemberPage from '@/views/space/MemberPage.vue'
import Home from '@/views/Home.vue'
import SpacesPage from '@/views/spaces/Index.vue'

import Team from '@/views/team/Index.vue'
import MemberBilling from '@/views/team/Billing.vue'
import InviteMember from '@/components/actions/wizards/InviteMemberWizard/index.vue'
import TeamMember from '@/views/team/TeamMember.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    beforeEnter: Auth.loginRequired
  },
  {
    path: '/guide/:guide?',
    name: 'Guide',
    component: Home,
    props: true,
    beforeEnter: Auth.loginRequired
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '../views/auth/Index.vue')
  },
  {
    path: '/feed',
    name: 'Business Feed',
    component: () => import(/* webpackChunkName: "business-feed" */ '../views/BusinessFeed.vue'),
    beforeEnter: Auth.loginRequired,
    props: { title: 'Activity Feed', text: 'Activity feed for your business' }
  },
  {
    path: '/brand',
    name: 'Brand Index',
    component: () => import(/* webpackChunkName: "login" */ '../views/brand/Index.vue'),
    beforeEnter: Auth.loginRequired,
    props: { title: 'Brand Overview', text: 'This page will give you an overview how your various brand assets look in AppointmentGuru' }
  },
  {
    path: '/brand/:spaceId?',
    name: 'Brand Overview',
    props: true,
    component: () => import(/* webpackChunkName: "settings-at" */ '../views/brand/Index.vue'),
    beforeEnter: Auth.loginRequired
  },
  {
    path: '/settings/manage/:page?/:initialSpaceId?/:initialPractitionerId?',
    name: 'Manage settings',
    props: true,
    component: () => import(/* webpackChunkName: "manage-at" */ '../views/Manage.vue'),
    beforeEnter: Auth.loginRequired
  },
  {
    path: '/settings/spaces/:spaceId/appointment-types/:productId',
    name: 'Appointment Types',
    props: true,
    component: () => import(/* webpackChunkName: "settings-at" */ '../views/space/AppointmentTypePage.vue'),
    beforeEnter: Auth.loginRequired
  },
  {
    path: '/settings/spaces/:spaceId/members/:memberId',
    name: 'Member',
    // component: MemberPage,
    props: true,
    component: () => import(/* webpackChunkName: "settings-member" */ '../views/space/MemberPage.vue'),
    beforeEnter: Auth.loginRequired
  },
  {
    path: '/settings/spaces/:spaceId/locations/:locationId/hours',
    name: 'Operating Hours',
    // component: MemberPage,
    props: true,
    component: () => import(/* webpackChunkName: "settings-operating-hours" */ '../views/space/OperatingHoursPage.vue'),
    beforeEnter: Auth.loginRequired
  },
  {
    path: '/settings/spaces/:spaceId/locations/:locationId',
    name: 'Location',
    // component: MemberPage,
    props: true,
    component: () => import(/* webpackChunkName: "settings-space-address" */ '../views/space/LocationPage.vue'),
    beforeEnter: Auth.loginRequired
  },
  {
    path: '/settings/spaces/:spaceId/:page?',
    name: 'Space Settings',
    props: true,
    component: () => import(/* webpackChunkName: "settings-space" */ '../views/space/Index.vue'),
    beforeEnter: Auth.loginRequired
  },
  // wizards:
  { // no login required
    path: '/wizards/join/:spaceId/:inviteKey',
    name: 'Join Space',
    props: true,
    component: () => import(/* webpackChunkName: "join-space-wizard" */ '../components/actions/wizards/JoinSpaceWizard/index.vue')
  },
  {
    path: '/wizards/invite/:spaceId?',
    name: 'Invite member',
    props: true,
    component: () => import(/* webpackChunkName: "invite-member-wizard" */ '../components/actions/wizards/InviteMemberWizard/index.vue'),
    beforeEnter: Auth.loginRequired
  },
  {
    path: '/wizards/new-location/:spaceId?',
    name: 'New location',
    props: true,
    component: () => import(/* webpackChunkName: "new-location-wizard" */ '../components/actions/wizards/NewLocationWizard.vue'),
    beforeEnter: Auth.loginRequired
  },
  {
    path: '/wizards/appointment-types/:spaceId/:practitionerId?',
    name: 'New Appointment Type',
    component: () => import(/* webpackChunkName: "new-appointment-type" */ '../components/actions/wizards/AppointmentTypeWizard/index.vue'),
    props: true,
    beforeEnter: Auth.loginRequired
  },
  {
    path: '/wizards/space/:spaceId?',
    name: 'New Space',
    props: true,
    component: () => import(/* webpackChunkName: "new-space-wizard" */ '../components/actions/wizards/SpaceWizard/Decision.vue'),
    beforeEnter: Auth.loginRequired
  },
  {
    path: '/wizards/converge/',
    name: 'Converge spaces',
    props: true,
    component: () => import(/* webpackChunkName: "converge-spaces" */ '../components/actions/wizards/ConvergeSpacesWizard/index.vue'),
    beforeEnter: Auth.loginRequired
  },
  // tools:
  {
    path: '/tools/suggest/:spaceId?',
    name: 'Configuration suggestions',
    component: () => import(/* webpackChunkName: "login" */ '../components/ui/PlaceHolder.vue'),
    beforeEnter: Auth.loginRequired,
    props: { title: 'Suggestions', text: 'This page will diagnose your account setup and suggest some things for you to do in order to get the most out of AppointmentGuru' }
  },
  {
    path: '/tools/transfer-appointments',
    name: 'Transfer appointments',
    props: true,
    component: () => import(/* webpackChunkName: "transfer-appointment" */ '../views/tools/TransferAppointments.vue'),
    beforeEnter: Auth.loginRequired
  },
  {
    path: '/tools/update-pricing',
    name: 'Update pricing',
    props: true,
    component: () => import(/* webpackChunkName: "update-pricing" */ '../views/tools/PriceUpdateTool/index.vue'),
    beforeEnter: Auth.loginRequired
  },
  {
    path: '/settings/me/:page?/:detail?',
    name: 'Profile',
    props: true,
    component: () => import(/* webpackChunkName: "settings-spaces" */ '../views/profile/Index.vue'),
    beforeEnter: Auth.loginRequired
  },
  {
    path: '/settings/spaces/',
    name: 'Settings',
    component: SpacesPage,
    // component: () => import(/* webpackChunkName: "settings-spaces" */ '../views/spaces/Index.vue'),
    beforeEnter: Auth.loginRequired
  },
  {
    path: '/settings/team/',
    name: 'Team',
    component: Team,
    // component: () => import(/* webpackChunkName: "settings-team" */ '../views/team/Index.vue'),
    beforeEnter: Auth.loginRequired,
    children: [
      {
        name: 'billing',
        path: '/',
        component: MemberBilling
      },
      {
        path: 'new',
        component: InviteMember
      },
      {
        path: 'spaces/:spaceId/:page?',
        props: true,
        component: () => import(/* webpackChunkName: "team-settings-space" */ '../views/space/Index.vue')
      },
      {
        path: ':businessId/:practitionerId/:tab?',
        component: TeamMember,
        props: true
      }
    ]
  },
  {
    path: '/settings/billing/',
    name: 'Billing',
    // component: SpacesPage,
    component: () => import(/* webpackChunkName: "settings-billing" */ '../views/settings/Billing.vue'),
    beforeEnter: Auth.loginRequired
  }
  // {
  //   path: '/settings/spaces/:spaceId/appointment-types/',
  //   name: 'AppointmentTypes',
  //   props: true,
  //   component: AppointmentTypes,
  //   // component: () => import(/* webpackChunkName: "settings-appointment-types" */ '../views/settings/AppointmentTypes.vue'),
  //   beforeEnter: Auth.loginRequired
  // }
]

const router = new VueRouter({
  routes
})

export default router
